import { notification } from "antd";

export const ShowNotification = {
  Error(messageParam: string, descriptionParam: string) {
    notification.error({
      message: messageParam,
      description: descriptionParam
    });
  },

  Warn(messageParam: string, descriptionParam: string) {
    notification.warn({
      message: messageParam,
      description: descriptionParam
    });
  },

  Success(messageParam: string, descriptionParam: string) {
    notification.success({
      message: messageParam,
      description: descriptionParam
    });
  },

  Info(messageParam: string, descriptionParam: string) {
    notification.info({
      message: messageParam,
      description: descriptionParam
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/common/ShowNotification/ShowNotification.ts